import { createExperimentHook } from '@prisjakt/ui-experiment';

export const useChangelogPositionExperiment = createExperimentHook(
  'changelog-position',
  true,
  { alternate: false }
);

export type SearchResultLayoutExperimentType =
  | boolean
  | 'wide'
  | 'without panorama'
  | 'wide and without panorama';

export const useSearchResultLayoutExperiment = createExperimentHook<
  SearchResultLayoutExperimentType
>('search-result-layout', false, {
  wide: 'wide',
  withoutPanorama: 'without panorama',
  wideAndWithoutPanorama: 'wide and without panorama',
});

export type PanoramaAdInContentExperimentType =
  | boolean
  | 'trailing skyscraper without top panorama ad'
  | 'trailing skyscraper without top panorama ad with panorama ad in content';

export const usePanoramaAdInContentExperiment = createExperimentHook<
  PanoramaAdInContentExperimentType
>('panorama-ad-in-content', false, {
  trailingSkyscraperWithoutTopPanoramaAd:
    'trailing skyscraper without top panorama ad',
  trailingSkyscraperWithoutTopPanoramaAdWithPanoramaAdInContent:
    'trailing skyscraper without top panorama ad with panorama ad in content',
});

export const useMobileTopAdExperiment = createExperimentHook<boolean>(
  'mobile-top-ad-experiment',
  false,
  {
    showTopAd: true,
  }
);

export const useOurChoiceExperiment = createExperimentHook(
  'our-choice-experiment',
  false,
  {
    enabled: true,
  }
);

export type ListCardClickoutExperimentType =
  | boolean
  | 'clickout and list default'
  | 'list default';

export const useListCardClickoutExperiment = createExperimentHook<
  ListCardClickoutExperimentType
>('list-card-clickout', false, {
  clickoutAndListDefault: 'clickout and list default',
  listDefault: 'list default',
});

export type OfferItemExperimentType =
  | boolean
  | 'new with CTA button'
  | 'new without CTA button';

export enum ExperimentOfferItemEnum {
  NEW_WITH_CTA_BUTTON = 'new with CTA button',
  NEW_WITHOUT_CTA_BUTTON = 'new without CTA button',
}

export const useNewProductOfferItemExperiment = createExperimentHook<
  OfferItemExperimentType
>('new-product-offer-item', false, {
  newWithCTAButton: 'new with CTA button',
  newWithoutCTAButton: 'new without CTA button',
});

export const useKWLPWidePageExperiment = createExperimentHook(
  'kwlp-wide-page',
  false,
  {
    wide: true,
  }
);

export type StorePageConversionType =
  | boolean
  | 'popular products'
  | 'popular categories';

export const useStorePageConversionExperiment = createExperimentHook<
  StorePageConversionType
>('store-page-conversion', false, {
  popularProducts: 'popular products',
  popularCategories: 'popular categories',
});
